<script setup lang="ts">
import { onMounted, ref } from 'vue'

const isShown = ref<boolean>(false)

onMounted(() => {
  isShown.value = true
})
</script>

<template>
  <Transition name="dialog-anim">
    <section
      v-if="isShown"
      class="dialog-curtain full custom-modal"
      @click.stop
    >
      <div class="content max-h-full">
        <slot></slot>
      </div>
    </section>
  </Transition>
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.dialog-curtain.full {
  @apply fixed flex w-full h-full bottom-0 left-0 right-0 justify-center items-center md:py-8;
  z-index: 997;
  background-color: rgba(0, 0, 0, 0.4);
}

.dialog-curtain.full .content {
  @apply overflow-y-auto;
  position: relative;
}
</style>
